import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "date-field-container" };
const _hoisted_2 = { class: "date-label" };
const _hoisted_3 = ["value", "disabled"];
const _hoisted_4 = { class: "date-actions" };
const _hoisted_5 = { class: "calendar-content" };
const _hoisted_6 = { class: "calendar-header" };
const _hoisted_7 = { class: "month-year-selector" };
const _hoisted_8 = {
    key: 0,
    class: "picker-grid month-picker"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 1,
    class: "picker-grid year-picker"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 2,
    class: "calendar-grid"
};
const _hoisted_13 = { class: "weekday-header" };
const _hoisted_14 = { class: "days-grid" };
const _hoisted_15 = ["onClick"];
import { ref, computed, useTemplateRef } from 'vue';
import DrawerPanel from './DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DateFieldDrawer',
    props: {
        modelValue: { default: null },
        label: {},
        required: { type: Boolean, default: false },
        clearable: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        theme: { default: null }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const drawerPanel = useTemplateRef('drawerPanel');
        const today = new Date();
        const viewMonth = ref(today.getMonth());
        const viewYear = ref(today.getFullYear());
        const showMonthPicker = ref(false);
        const showYearPicker = ref(false);
        const weekdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const textValue = ref('');
        const displayValue = computed(() => {
            if (!props.modelValue)
                return '';
            if (typeof props.modelValue === 'string')
                return props.modelValue;
            if (props.modelValue instanceof Date)
                return formatDate(props.modelValue);
            return '';
        });
        const selectedDate = computed(() => {
            if (!props.modelValue)
                return null;
            if (props.modelValue instanceof Date)
                return props.modelValue;
            if (typeof props.modelValue === 'string')
                return parseDate(props.modelValue);
            return null;
        });
        const calendarDays = computed(() => {
            const days = [];
            const firstDay = new Date(viewYear.value, viewMonth.value, 1);
            const lastDay = new Date(viewYear.value, viewMonth.value + 1, 0);
            let startDay = firstDay.getDay() - 1;
            if (startDay < 0)
                startDay = 6;
            const prevMonth = new Date(viewYear.value, viewMonth.value, 0);
            for (let i = startDay - 1; i >= 0; i--) {
                days.push({
                    date: prevMonth.getDate() - i,
                    month: viewMonth.value - 1,
                    year: viewMonth.value === 0 ? viewYear.value - 1 : viewYear.value,
                    otherMonth: true
                });
            }
            for (let i = 1; i <= lastDay.getDate(); i++) {
                days.push({
                    date: i,
                    month: viewMonth.value,
                    year: viewYear.value,
                    otherMonth: false
                });
            }
            const remaining = 42 - days.length;
            for (let i = 1; i <= remaining; i++) {
                days.push({
                    date: i,
                    month: viewMonth.value + 1,
                    year: viewMonth.value === 11 ? viewYear.value + 1 : viewYear.value,
                    otherMonth: true
                });
            }
            return days;
        });
        const yearRange = computed(() => {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = currentYear - 100; i <= currentYear + 10; i++) {
                years.push(i);
            }
            return years;
        });
        function formatDate(date) {
            if (!date)
                return '';
            const d = date.getDate().toString().padStart(2, '0');
            const m = (date.getMonth() + 1).toString().padStart(2, '0');
            const y = date.getFullYear();
            return `${d}/${m}/${y}`;
        }
        function parseDate(str) {
            if (!str)
                return null;
            const parts = str.split('/');
            if (parts.length !== 3)
                return null;
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            if (isNaN(day) || isNaN(month) || isNaN(year))
                return null;
            return new Date(year, month, day);
        }
        function handleTextInput(event) {
            const target = event.target;
            const isDelete = event.inputType && event.inputType.startsWith('delete');
            let value = target.value;
            if (isDelete) {
                value = value.replace(/[^\d/]/g, '');
            }
            else {
                value = value.replace(/[^\d]/g, '');
                if (value.length >= 2) {
                    value = value.substring(0, 2) + '/' + value.substring(2);
                }
                if (value.length >= 5) {
                    value = value.substring(0, 5) + '/' + value.substring(5, 9);
                }
            }
            target.value = value;
            if (value.length === 10) {
                validateAndFormat({ target: { value } });
            }
        }
        function validateAndFormat(event) {
            const value = event.target.value;
            if (!value) {
                emit('update:modelValue', null);
                return;
            }
            const date = parseDate(value);
            if (date && !isNaN(date.getTime())) {
                emit('update:modelValue', formatDate(date));
            }
        }
        function openDrawer() {
            if (props.disabled)
                return;
            if (selectedDate.value) {
                viewMonth.value = selectedDate.value.getMonth();
                viewYear.value = selectedDate.value.getFullYear();
            }
            else {
                const today = new Date();
                viewMonth.value = today.getMonth();
                viewYear.value = today.getFullYear();
            }
            showMonthPicker.value = false;
            showYearPicker.value = false;
            drawerPanel.value?.openDrawer();
        }
        function clearValue() {
            emit('update:modelValue', null);
        }
        function previousMonth() {
            if (viewMonth.value === 0) {
                viewMonth.value = 11;
                viewYear.value--;
            }
            else {
                viewMonth.value--;
            }
        }
        function nextMonth() {
            if (viewMonth.value === 11) {
                viewMonth.value = 0;
                viewYear.value++;
            }
            else {
                viewMonth.value++;
            }
        }
        function selectMonth(index) {
            viewMonth.value = index;
            showMonthPicker.value = false;
        }
        function selectYear(year) {
            viewYear.value = year;
            showYearPicker.value = false;
        }
        function selectDate(day) {
            const date = new Date(day.month < 0 ? day.year : (day.month > 11 ? day.year : viewYear.value), day.month < 0 ? 11 : (day.month > 11 ? 0 : day.month), day.date);
            emit('update:modelValue', formatDate(date));
            setTimeout(() => {
                drawerPanel.value?.closeDrawer();
            }, 150);
        }
        function goToToday() {
            const today = new Date();
            viewMonth.value = today.getMonth();
            viewYear.value = today.getFullYear();
            emit('update:modelValue', formatDate(today));
            setTimeout(() => {
                drawerPanel.value?.closeDrawer();
            }, 150);
        }
        function isSelected(day) {
            if (!selectedDate.value)
                return false;
            return (day.date === selectedDate.value.getDate() &&
                day.month === selectedDate.value.getMonth() &&
                (day.otherMonth ? true : day.year === selectedDate.value.getFullYear()));
        }
        function isToday(day) {
            const today = new Date();
            return (day.date === today.getDate() &&
                day.month === today.getMonth() &&
                !day.otherMonth &&
                viewYear.value === today.getFullYear());
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["date-input-wrapper", { disabled: _ctx.disabled, dark: _ctx.theme === 'dark' }])
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["date-input-content", { 'has-value': displayValue.value }])
                    }, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label) + " " + _toDisplayString(_ctx.required ? '*' : ''), 1),
                        _createElementVNode("input", {
                            type: "text",
                            class: "date-input",
                            value: displayValue.value,
                            onInput: handleTextInput,
                            onBlur: validateAndFormat,
                            placeholder: "DD/MM/YYYY",
                            disabled: _ctx.disabled,
                            inputmode: "numeric",
                            maxlength: "10"
                        }, null, 40, _hoisted_3)
                    ], 2),
                    _createElementVNode("div", _hoisted_4, [
                        (_ctx.modelValue && _ctx.clearable && !_ctx.disabled)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "date-clear",
                                onClick: _withModifiers(clearValue, ["stop"])
                            }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode("mdi-close")
                                ])),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_v_icon, {
                            class: _normalizeClass(["date-calendar", { disabled: _ctx.disabled }]),
                            onClick: _withModifiers(openDrawer, ["stop"])
                        }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("mdi-calendar")
                            ])),
                            _: 1
                        }, 8, ["class"])
                    ])
                ], 2),
                _createVNode(DrawerPanel, {
                    ref_key: "drawerPanel",
                    ref: drawerPanel,
                    title: _ctx.label,
                    divider: false,
                    close: true,
                    openHeight: "70%",
                    closedHeight: "0px",
                    bottom: "0",
                    backgroundColor: "#fff",
                    openBackgroundColor: "#fff",
                    blurBackground: true
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_v_icon, {
                                    class: "nav-arrow",
                                    onClick: previousMonth
                                }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                        _createTextVNode("mdi-chevron-left")
                                    ])),
                                    _: 1
                                }),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("span", {
                                        class: "current-month",
                                        onClick: _cache[0] || (_cache[0] = ($event) => { showMonthPicker.value = !showMonthPicker.value; showYearPicker.value = false; })
                                    }, _toDisplayString(monthNames[viewMonth.value]), 1),
                                    _createElementVNode("span", {
                                        class: "current-year",
                                        onClick: _cache[1] || (_cache[1] = ($event) => { showYearPicker.value = !showYearPicker.value; showMonthPicker.value = false; })
                                    }, _toDisplayString(viewYear.value), 1)
                                ]),
                                _createVNode(_component_v_icon, {
                                    class: "nav-arrow",
                                    onClick: nextMonth
                                }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createTextVNode("mdi-chevron-right")
                                    ])),
                                    _: 1
                                })
                            ]),
                            (showMonthPicker.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(monthNames, (month, index) => {
                                        return _createElementVNode("div", {
                                            key: month,
                                            class: _normalizeClass(["picker-item", { selected: index === viewMonth.value }]),
                                            onClick: ($event) => (selectMonth(index))
                                        }, _toDisplayString(month.substring(0, 3)), 11, _hoisted_9);
                                    }), 64))
                                ]))
                                : _createCommentVNode("", true),
                            (showYearPicker.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearRange.value, (year) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: year,
                                            class: _normalizeClass(["picker-item", { selected: year === viewYear.value }]),
                                            onClick: ($event) => (selectYear(year))
                                        }, _toDisplayString(year), 11, _hoisted_11));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true),
                            (!showMonthPicker.value && !showYearPicker.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (day) => {
                                            return _createElementVNode("span", {
                                                key: day,
                                                class: "weekday"
                                            }, _toDisplayString(day), 1);
                                        }), 64))
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarDays.value, (day, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: _normalizeClass(["day-cell", {
                                                        'other-month': day.otherMonth,
                                                        'selected': isSelected(day),
                                                        'today': isToday(day)
                                                    }]),
                                                onClick: ($event) => (selectDate(day))
                                            }, _toDisplayString(day.date), 11, _hoisted_15));
                                        }), 128))
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", { class: "calendar-footer" }, [
                                _createElementVNode("button", {
                                    class: "today-button",
                                    onClick: goToToday
                                }, "Today")
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["title"])
            ]));
        };
    }
});
